(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["accordian-with-image-meta"] && !window.DesignMode) return;
  try {
    
  document.querySelectorAll('.accordian-container .question').forEach(function (question) {
    question.addEventListener('click', function () {
      // Remove 'active' class from all 'question' elements
      document.querySelectorAll('.accordian-container .active').forEach(function (activeQuestion) {
        activeQuestion.classList.remove('active');
      });
      this.parentNode.classList.add('active');
      var id = this.parentNode.getAttribute('data-id');
      document.querySelectorAll('.accordian-image img').forEach(function (activeImage) {
        activeImage.classList.remove('active');
      });
      var targetImages = document.querySelectorAll('.accordian-image .' + id);
      targetImages.forEach(function (targetImage) {
        targetImage.classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accordian-with-img"] && !window.DesignMode) return;
  try {
    
  
document.querySelectorAll('.accordian-container .question').forEach(function (question) {
    question.addEventListener('click', function () {
        // Remove 'active' class from all 'question' elements
        document.querySelectorAll('.accordian-container .active').forEach(function (activeQuestion) {
            activeQuestion.classList.remove('active');
        });
        this.parentNode.classList.add('active');
        var id = this.parentNode.getAttribute('data-id');       
        document.querySelectorAll('.accordian-image img').forEach(function (activeImage) {
            activeImage.classList.remove('active');
        });
        var targetImages = document.querySelectorAll('.accordian-image .' + id);
        targetImages.forEach(function (targetImage) {
            targetImage.classList.add('active');          
        });
       
    });
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before_after_slider"] && !window.DesignMode) return;
  try {
    
  function waitForSwiper(trigger) {
    var interval = setInterval(function () {
      if (typeof Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
      }
    });
    setTimeout(function () {
      clearInterval(interval);
    }, 15000);
  }

  function conversionSlider() {
    var swiper = new Swiper('.before-after-slider', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true,
      spaceBetween: 40,
      breakpoints: {
        769: {
          slidesPerView: 2,
          autoplay: false,
          spaceBetween: 40,
        },
        0: {
          slidesPerView: 1,
          // direction: 'horizontal',
        },
      },
    });
  }

  waitForSwiper(function () {
    conversionSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq_meta"] && !window.DesignMode) return;
  try {
    
  var accordionTitles = document.querySelectorAll(".faq-list__item");
        accordionTitles.forEach((accordionTitle) => {
        accordionTitle.addEventListener("click", () => {
        if (accordionTitle.classList.contains("is-open")) {
          accordionTitle.classList.remove("is-open");
        }

        else {
        var accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
         accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
          accordionTitleWithIsOpen.classList.remove("is-open");
        });
        accordionTitle.classList.add("is-open");
       }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp_before_after"] && !window.DesignMode) return;
  try {
    

   function waitForSwiper(trigger) {
            var interval = setInterval(function () {
                if (typeof Swiper != 'undefined') {
                    clearInterval(interval);
                    trigger();
                }
            })
            setTimeout(function () {
                clearInterval(interval);
            }, 15000)
        }

   function conversionSlider() {
                var swiper = new Swiper('.conversion-swiper', {

                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    loop: true,
                    spaceBetween: 15,
                    breakpoints: {
                        769: {
                            slidesPerView: 1,
                            autoplay: false,
                        },
                        0: {
                            slidesPerView: 1,
                            // direction: 'horizontal',
                        }
                    },
                });
            }

  waitForSwiper(conversionSlider);

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-slider"] && !window.DesignMode) return;
  try {
    
  function waitForSwiper(trigger) {
    var interval = setInterval(function () {
      if (typeof Swiper != 'undefined') {
        clearInterval(interval);
        trigger();
      }
    });
    setTimeout(function () {
      clearInterval(interval);
    }, 15000);
  }

  
  function calculateRealIndex(activeIndex, sliderInstance) {
    console.log("calculate real index")
      // Check for duplicate slides
    var currentSlideIndex = sliderInstance.slides.length - sliderInstance.params.slidesPerView - sliderInstance.loopedSlides

    if (activeIndex - currentSlideIndex > 0) {
        return Math.ceil(activeIndex - currentSlideIndex); // Adjust for loop offset
    }

    // Here's the logic to calculate real index based on activeIndex and slider configuration
    var slidesCount = sliderInstance.slides.length;
  
    // Consider edge cases like loop and single slide
    if (activeIndex === 0 && sliderInstance.looped) {
      return slidesCount - 1;
    } else if (activeIndex === slidesCount - 1 && sliderInstance.looped) {
      return 0;
    }
  
    // Calculate real index based on centered slide offset
    var centeredSlides = sliderInstance.params.slidesPerView;
    var offset = (sliderInstance.width - (sliderInstance.slidesSizesGrid[activeIndex] * sliderInstance.zoom)) / 2;
  
    // Loop through previous slides to find the start of the centered view
    var realIndex = activeIndex;
    while (offset > 0 && realIndex > 0) {
      offset -= sliderInstance.slidesSizesGrid[realIndex - 1] * sliderInstance.zoom;
      realIndex--;
    }
  
    return realIndex;
  }

  function ingredientSlider() {
    
    var slider = new Swiper('.ingredients_slider--details', {
      slidesPerView: 1,
      centeredSlides: false,
      loop: false,
      spaceBetween: 15,
      slideToClickedSlide: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

     var thumbs = new Swiper('.ingredients_slider', {
      spaceBetween: 30,
      loop: false,
      slideToClickedSlide: true,
      centeredSlides: true,
      breakpoints: {
        769: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        0: {
          slidesPerView: 1.75,
          spaceBetween: 10,
        },
      },
    });

    // slider.on('slideChange', function(){
    //       var activeIndex = this.activeIndex;
    //       var realIndex = calculateRealIndex(activeIndex, this);
    //       thumbs.slideTo(realIndex);
    // })
    
    // thumbs.on('slideChange', function(){
    //       var activeIndex = this.activeIndex;
    //       var realIndex = calculateRealIndex(activeIndex, this);
    //       slider.slideTo(realIndex);
    // })

    slider.controller.control = thumbs;
    thumbs.controller.control = slider;

    slider.slideTo(1, false,false);
  }

  // Wait for Swiper to be ready before initializing the slider
  waitForSwiper(function () {
    ingredientSlider();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-faq"] && !window.DesignMode) return;
  try {
    

var accordionTitles = document.querySelectorAll(".faq-list__item");
      accordionTitles.forEach((accordionTitle) => {
      accordionTitle.addEventListener("click", () => {
      if (accordionTitle.classList.contains("is-open")) {
        accordionTitle.classList.remove("is-open");
      }
        
      else {
      var accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
       accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
        accordionTitleWithIsOpen.classList.remove("is-open");
      });
      accordionTitle.classList.add("is-open");
     }
    });
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_sticky_header"] && !window.DesignMode) return;
  try {
    

function handleScroll() {
  if (window.scrollY > 30) {
    document.querySelector('[id*="pdp_sticky_header"]').classList.add('scrolled')
  } else {
    document.querySelector('[id*="pdp_sticky_header"]').classList.remove('scrolled')
  }
}
window.addEventListener('scroll', handleScroll);
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progress-sec"] && !window.DesignMode) return;
  try {
    

const block = document.querySelectorAll(".block");
window.addEventListener("load", function () {
block.forEach((item) => {
let numElement = item.querySelector(".num");
let num = parseFloat(numElement.innerText);
let count = 0;
let time = 2000 / num;
let circle = item.querySelector(".circle");
let interval = setInterval(() => {
if (count >= num) {
clearInterval(interval);
} else {
count += num;
numElement.innerText = count.toFixed(2);
}
}, time);
circle.style.strokeDashoffset = 503 - 5.03 * num;
let dots = item.querySelector(".dots");
dots.style.transform = `rotate(${360 * (num / 100)}deg)`;
if (num == 100) {
dots.style.opacity = 0;
}
});
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-with-load-more"] && !window.DesignMode) return;
  try {
    

    var loadMoreButton = document.querySelector(".loyal-customer-sec .loyal-customer-container .load-more-button");

            loadMoreButton.addEventListener("click", function (e) {
                e.preventDefault();
                document.querySelector('.loyal-customer-sec').classList.toggle('show_reviews')

            });

     var doc = document.querySelectorAll('.loyal-customer-sec .loyal-customer-container .column .row .review-card');


var docArray = Array.from(doc);

if (docArray.length > 6) {
  
    var lastThree = docArray.slice(-3);

    lastThree.forEach(function(ele) {
        ele.classList.add('more-review');
    });
}

  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-footer"] && !window.DesignMode) return;
  try {
    

 function clickOperation() {
       

        var stickyFooterCloseBtn = document.querySelector('.custCloseIcon');
        if (stickyFooterCloseBtn) {
            stickyFooterCloseBtn.addEventListener('click', function () {
                
                document.querySelector('.custmaySaleEventStickly').style.display = 'none';
            });
        }

    }

    clickOperation();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc_sec"] && !window.DesignMode) return;
  try {
    
function live(selector, event, callback, context) {
    // helper for enabling IE 8 event bindings
    function addEvent(el, type, handler) {
        if (el.attachEvent) el.attachEvent("on" + type, handler);
        else el.addEventListener(type, handler);
    }
    // matches polyfill
    this &&
        this.Element &&
        (function (ElementPrototype) {
            ElementPrototype.matches =
                ElementPrototype.matches ||
                ElementPrototype.matchesSelector ||
                ElementPrototype.webkitMatchesSelector ||
                ElementPrototype.msMatchesSelector ||
                function (selector) {
                    var node = this,
                        nodes = (node.parentNode || node.document).querySelectorAll(selector),
                        i = -1;
                    while (nodes[++i] && nodes[i] != node);
                    return !!nodes[i];
                };
        })(Element.prototype);
    // live binding helper using matchesSelector
    function live(selector, event, callback, context) {
        addEvent(context || document, event, function (e) {
            var found,
                el = e.target || e.srcElement;
            while (el && el.matches && el !== context && !(found = el.matches(selector)))
                el = el.parentElement;
            if (found) callback.call(el, e);
        });
    }
    live(selector, event, callback, context);
}

live(".our-customer-stories-section .customer-content .video-details", "click", function () {
    var videoId = this.getAttribute("data-attr");
    var video = document.querySelector('.video-popup video');

    console.log("player video play");

    // Update video source
    video.querySelector('source').setAttribute('src', videoId);

    // Load the new source
    video.load();

    // Play the video
    video.play();
    document.body.classList.add("popupshow");
});

live(".video-popup .overlay", "click", function () {
    console.log('hii')
    document.body.classList.remove("popupshow");

    var video = document.querySelector('.video-popup video');

    // Pause the video
    video.pause();

    // Remove the src attribute
    video.removeAttribute('src');
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
      })();
